<template>
  <div>
    <v-snackbar
      v-model="popup.visbile"
      :color="popup.type"
      :timeout="3000"
      :bottom="'bottom'"
      class="custom-snackbar"
    >
      {{ popup.text }}
      <v-btn dark text @click="popup.visible = false">Close</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="showPlanAndPaymentPage"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      app
    >
    <PlanAndPayment 
      v-bind:showPlanAndPaymentPage="showPlanAndPaymentPage" 
      v-bind:page="'payment'" 
      v-bind:selectedLocation="paymentNas"
      v-bind:editUpi="editUpi" 
      v-bind:fromSettings="false"
      v-on:close="showPlanAndPaymentPage = false"></PlanAndPayment>
    </v-dialog>
    <v-list color="#f26547" style="border-radius: 0px;" id="sidebar-merchant-details">
      <v-list-item>
        <v-list-item-avatar height="64" width="64">
          <v-avatar color="red" v-if="owner.profilePhoto == null || owner.profilePhoto == ''">
            <span class="white--text headline" v-if="owner.ownerName">
              {{
              owner.ownerName.toString().substring(0, 1)
              }}
            </span>
          </v-avatar>
          <v-avatar color="red" v-if="owner.profilePhoto != null && owner.profilePhoto != ''">
            <img :src="owner.profilePhoto" :alt="owner.ownerName" />
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="fs-14">
            <span class="fontwhite-bold">{{ owner.ownerName }}</span>
          </v-list-item-title>
          <v-list-item-subtitle class="fs-12">
            <span class="fontwhite">{{ owner.ownerEmailId }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="fs-12">
            <span class="fontwhite">{{ formatNumber(owner.ownerNumber) }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-icon style="bottom: -20px;" color="#ffffff" @click="EditMerchantProfile()">mdi-pencil</v-icon>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <div id="sidebar-locations-container">
      <v-expansion-panels id="sidebar-locations" focusable flat>
        <v-expansion-panel
          v-for="(location, i) in storeData"
          :key="i"
          style="padding-top:0px !important;margin-top:0px;"
        >
          <v-expansion-panel-header
            id="location"
            ripple
            dense
            class="warm-grey fs-12 px-2 py-2 compact"
            style="min-height:36px;color:#214294; font-weight:600;background-color:#fafafa;"
          >{{ location.storeName }}</v-expansion-panel-header>
          <v-expansion-panel-content style="background-color:#fafafa">
            <div style="margin-left:-5px !important">
              <v-icon
                dense
                @click="EditLocation(location)"
                style="position:absolute;right:15px;font-size: 24px;"
                class="mt-2"
              >mdi-pencil</v-icon>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Manager Name</span>
                <span>:</span>
                <span class="location-value">{{ location.managerName }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Manager Mobile</span>
                <span>:</span>
                <span class="location-value">{{ location.managerPhone }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Manager Email</span>
                <span>:</span>
                <span class="location-value">{{ location.managerEmail }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Address</span>
                <span>:</span>
                <span class="location-value">{{ location.address }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Category</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ prepDisplayCategory(location.category).name }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">SubCategory</span>
                <span>:</span>
                <span class="location-value" style="text-transform:capitalize">
                  {{
                  prepDisplaySubcategory(
                  location.category,
                  location.subCategory
                  ).name
                  }}
                </span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Opening Time</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ location.locationOpeningTime.substring(0, 5) }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Closing Time</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ location.locationClosingTime.substring(0, 5) }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Legal Business Name</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ location.legalBusinessName }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">Legal Business Address</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ location.legalBusinessAddress }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">GST Number</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:capitalize"
                >{{ location.gstNumber }}</span>
              </div>
              <div class="pt-2 grid-sidebar-locationdetails compact">
                <span class="location-field">UPI ID</span>
                <span>:</span>
                <span
                  class="location-value"
                  style="text-transform:lowercase"
                >
                  {{ location.upiId || 'Not Mentioned' }}
                  <v-icon
                    @click="
                      showPlanAndPaymentPage = true;
                      editUpi = true;
                      paymentNas = location
                    "
                    class="pl-3"
                    style="font-size:1rem;width:1rem;height:1rem;color:#f4693a"
                    >mdi-pencil</v-icon
                  >
                </span>
              </div>
              <div>
                <hr style="margin-top:10px;" />
                <span style="display:block;font-weight:bold;color:#333;margin-top:10px">Current Plan</span>
                <div class="pt-2 grid-sidebar-locationdetails compact">
                  <span class="location-field">Expiry Date</span>
                  <span>:</span>
                  <span
                    class="location-value"
                    style="text-transform:capitalize"
                  >{{ (location.subscription && location.subscription.end) || ((new Date(location.locationStartDate)).getFullYear()+1)+"-"+((new Date(location.locationStartDate)).getMonth()+1)+"-"+((new Date(location.locationStartDate)).getDate()) }}</span>
                </div>
                <div class="pt-2 grid-sidebar-locationdetails compact">
                  <span class="location-field">Package Name</span>
                  <span>:</span>
                  <span
                    class="location-value"
                    style="text-transform:capitalize"
                  >{{ (location.subscription && location.subscription.name) || 'WIOM Basic' }}</span>
                </div>
              </div>
              <span
                v-if="nonPremium(location)"
                @click="showPlans = true"
                style="display:block;font-weight:bold;color:#333;margin-top:10px;color:red"
              >Upgrade</span>
              <span
                v-if="!nonPremium(location)"
                @click="showPlans = true"
                style="display:block;font-weight:bold;color:#333;margin-top:10px;color:red"
              >
                <!--Renew-->
              </span>
              <v-dialog
                v-model="showPlans"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                app
              >
                <Plans v-bind:location="location" v-bind:view="upgrade" @close="showPlans = false"></Plans>
              </v-dialog>
              <div @click="geLocation = location;showGECampaign = !showGECampaign;"
              v-if="location.subscription.name == 'WIOM PDO'"
              style="color: white;background-color: rgb(240, 107, 105);padding: 1rem;position: relative;left: -1rem;width: calc(100% + 2rem);">
                PDO Guaranteed Income Scheme 
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-dialog
      v-model="editMerchantProfile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      app
    >
      <EditMerchantProfile
        v-bind:editMerchantProfile="editMerchantProfile"
        v-bind:userData="userData"
        v-bind:ownerDetails="owner"
        @save="saveMerchantProfile()"
        @close="closeEditMerchantProfile()"
      ></EditMerchantProfile>
    </v-dialog>
    <!-- Location Details Edit -->
    <v-dialog
      v-model="editLocationDetails"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      app
    >
      <EditLocationDetails
        v-bind:editLocationDetails="editLocationDetails"
        v-bind:editLocation="editLocation"
        v-bind:userId="userId"
        v-bind:opened="opened"
        @save="updateLocationDetails($event)"
        @close="closeEditLocationDetails()"
      ></EditLocationDetails>
    </v-dialog>
    <v-list-item-content style="position:absolute;bottom:50px;">
      <v-list-item-title class="fs-12 pl-4 pb-3">
        <a target="_blank" href="https://wiom.in/tnc.html"
        style="color:#214294;font-size:14px;">Terms & Conditions</a>
      </v-list-item-title>
      <v-list-item-title class="fs-12 pl-4 pb-3">
        <a target="_blank" href="https://wiom.in/privacyPolicy.html"
        style="color:#214294;font-size:14px;">Privacy Policy</a>
      </v-list-item-title>
      <v-list-item-title class="fs-12 pl-4 pb-3">
        <a href="tel:8880322222" style="color:#214294;font-size:14px;">Help & support</a>
      </v-list-item-title>
      <v-list-item-title class="fs-12 pl-4 pb-3">
        <button
          style="color:#214294;font-size:14px;"
          @click="showChangePassword = true"
        >Change Password</button>
      </v-list-item-title>
      <v-list-item-title class="fs-12 pl-4">
        <v-btn color="primary" id="submit" @click="logout()">Logout</v-btn>
      </v-list-item-title>
    </v-list-item-content>
    <ChangePassword
      ref="ch_pass"
      v-bind:userData="userData"
      v-bind:showChangePassword="showChangePassword"
      @updated-password="ReLogin($event)"
    ></ChangePassword>
    <v-dialog
      v-model="showGECampaign"
      fullscreen
      transition="dialog-bottom-transition"
      hide-overlay
      app
    >
    <GECampaign 
      v-bind:location="geLocation"
      v-bind:mobile="owner.ownerNumber"
      @back="showGECampaign = false"
    ></GECampaign>
    </v-dialog>
  </div>
</template>

<script>
import axios from "./../../plugins/axios";
import EditMerchantProfile from "./../sidebar/EditMerchantProfile";
import EditLocationDetails from "./../sidebar/EditLocationDetails";
import helper from "./../../utils/helper";
import Plans from "./../common/Plans";
import PlanAndPayment from "./../manage/PlanAndPayment";
import ChangePassword from "./../common/password/ChangePassword";
import GECampaign from "./GECampaign";
export default {
  name: "Sidebar",
  props: [
    "userId",
    "owner",
    "storeData",
    "selectedLocation",
    "userData",
    "subscriptions"
  ],
  components: {
    EditMerchantProfile,
    EditLocationDetails,
    Plans,
    ChangePassword,
    PlanAndPayment,
    GECampaign
  },
  data: function() {
    return {
      showPlanAndPaymentPage: false,
      editUpi: false,
      paymentNas: null,
      geLocation: null,
      showChangePassword: false,
      showGECampaign: false,
      upgrade: {},
      categories: helper.categories(),
      showPlans: false,
      opened: false,
      popup: {
        type: "info",
        visbile: false,
        text: ""
      },
      menudrawer: null,
      editMerchantProfile: false,
      editLocationDetails: false,
      editLocation: null,
      ownerName: "",
      ownerNumber: "",
      ownerEmailId: "",

      sideBarData: {},
      marketPlace: "",
      landmark: "",
      pincode: "",
      city: "",
      state: ""
    };
  },
  methods: {
    nonPremium: function(location) {
      if (location.subscription && location.subscription.active == true)
        return false;
      return true;
    },
    formatNumber: function(n) {
      if (!n || n == "") return "";
      else return `${n.substring(0, 5)}   ${n.substring(5, 10)}`;
    },
    prepDisplayCategory: function(category) {
      var result = { id: null, name: null };
      if (category && category != "")
        for (var x = 0; x < this.categories.categories.length; x++) {
          if (this.categories.categories[x].id == category)
            result = this.categories.categories[x];
        }
      return result;
    },
    prepDisplaySubcategory: function(cat, subcategory) {
      var result = { id: null, name: null };
      var category = this.prepDisplayCategory(cat);
      if (!category.id) return result;
      if (subcategory && subcategory != "")
        for (
          var y = 0;
          y < this.categories.subcategories[category.id].length;
          y++
        ) {
          if (this.categories.subcategories[category.id][y].id == subcategory)
            return this.categories.subcategories[category.id][y];
        }
      return result;
    },
    EditLocation: function(location) {
      //console.log("click edit", location);
      this.editLocation = null;
      this.editLocation = location;
      axios
        .get(
          "/wiom/getuserprofile?nasid=" +
            this.editLocation.nasid +
            "&classification=manager"
        )
        .then(response => {
          this.editLocation.managerUserId = response.data.data.id;
          this.editLocation.managerName = response.data.data.name;
          this.editLocation.managerNumber = response.data.data.mobile;
          this.editLocation.managerEmail = response.data.data.username;

          if (
            this.editLocation.locationOpeningTime == null ||
            this.editLocation.locationClosingTime == ""
          ) {
            this.editLocation.tempOpeningTime = "10:00";
            this.editLocation.placeHolderOpeningTime = true;
          } else {
            this.editLocation.tempOpeningTime = this.editLocation.locationOpeningTime.substring(
              0,
              5
            );
          }
          if (
            this.editLocation.locationClosingTime == null ||
            this.editLocation.locationClosingTime == ""
          ) {
            this.editLocation.tempClosingTime = "19:00";
            this.editLocation.placeHolderClosingTime = true;
          } else {
            this.editLocation.tempClosingTime = this.editLocation.locationClosingTime.substring(
              0,
              5
            );
          }
          this.editLocation.subCategory = this.prepDisplaySubcategory(
            this.editLocation.category,
            this.editLocation.subCategory
          );
          this.editLocation.category = this.prepDisplayCategory(
            this.editLocation.category
          );

          this.editLocationDetails = true;
          this.opened = true;
        });
    },
    EditMerchantProfile: function() {
      this.editMerchantProfile = true;
    },
    closeEditMerchantProfile: function() {
      this.editMerchantProfile = false;
      this.$emit("refresh-merchant-profile");
    },
    closeEditLocationDetails: function() {
      this.editLocationDetails = false;
      this.opened = false;
      this.$emit("refresh-location-details");
    },
    saveMerchantProfile: function() {
      this.$emit("refresh-merchant-profile");
      this.closeEditMerchantProfile();
      this.popup = {
        type: "success",
        text: "Merchant Profile Saved",
        visbile: true
      };
      this.$emit("update-merch-details");
    },
    updateLocationDetails: function() {
      this.closeEditLocationDetails();
      this.popup = {
        type: "success",
        text: "Location Details Saved",
        visbile: true
      };
      this.$emit("update-loc-details");
    },
    ReLogin: function(password) {
      this.showChangePassword = false;
      this.$emit("relogin", {username:this.userData.username, password:password});
    },
    logout: function() {
      this.$emit('logout');
    }
  }
};
</script>
